import { type ReactNode } from 'react'
import { ScrollableList } from '../../../../components/ScrollableList/ScrollableList'
import { ProductCardSkeleton } from './ProductCardSkeleton'

const SKELETON_CARD_COUNT = 4

interface ProductListProps {
  isLoading: boolean
  hasSubtitleChips?: boolean
  /** 列表開頭的固定元素，會跟著 children 一起橫滑。 */
  leadingSlot?: ReactNode
  /** 列表尾端的固定元素，會跟著 children 一起橫滑。例如「前往品牌頁」卡片。 */
  trailingSlot?: ReactNode
  /** 卡片列表本體。caller 自行 map entries 並決定要 render 哪種卡片。 */
  children?: ReactNode
}

export const ProductList = (props: ProductListProps) => {
  const { isLoading, hasSubtitleChips, leadingSlot, trailingSlot, children } = props

  if (isLoading) {
    return (
      <ScrollableList>
        {leadingSlot}
        {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
          <ProductCardSkeleton key={`skeleton-${index}`} hasSubtitleChips={hasSubtitleChips} />
        ))}
      </ScrollableList>
    )
  }

  return (
    <ScrollableList>
      {leadingSlot}
      {children}
      {trailingSlot}
    </ScrollableList>
  )
}
